import { combineReducers, configureStore } from '@reduxjs/toolkit'
import transportationReducer from './slices/transportation/transportationSlice'
import notificationReducer from './slices/notification/notificationSlice'
import appReducer from './slices/app/appSlice'

export const store = configureStore({
  reducer: combineReducers({
    transportation: transportationReducer,
    notification: notificationReducer,
    app: appReducer,
  }),
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
